import { t } from '@avalara/bat-apps-shared/i18n';
import { SBox } from '@avalara/skylab-sdk/react';

type CamPanelProps = {
  email: string | null;
  name: string | null;
  phone: string | null;
  photoUrl: string | null;
};

const CamPanel = ({ name, phone, email, photoUrl }: CamPanelProps) => (
  <div className='cam-panel' style={{ width: '250px' }}>
    <SBox className='margin-bottom-sm'>
      <h2 className='margin-top-none'>{t('client.headings.questions')}</h2>

      <img
        data-ref='buy.returns-thankyou.cam-image'
        src={photoUrl || undefined}
        className='left block clear'
        height='100px'
        alt={t('client.accessibility.your-customer-account-manager')}
      />

      <div className='left'>
        <h3 data-ref='buy.returns-thankyou.cam-name' className='margin-all-none margin-top-xs'>
          {name}
        </h3>
        <h3 data-ref='buy.returns-thankyou.cam-header' className='margin-all-none'>
          {t('client.headings.account-manager')}
        </h3>
        <p data-ref='buy.returns-thankyou.cam-phone' className='phone-number margin-bottom-none'>
          {phone}
        </p>
        {email != null && (
          <p className='margin-top-none'>
            <a data-ref='buy.returns-thankyou.cam-email.link' href={`mailto:${email}`}>
              {email}
            </a>
          </p>
        )}
      </div>
    </SBox>
  </div>
);
export default CamPanel;
